import type { GadgetColors } from "./EditTheme";

export const gadgetColorsLight = {
  neutralMin: "#FFF",
  neutralMax: "#000",

  primary50: "#F6F6F6",
  primary100: "#EEEEEE",
  primary200: "#E2E2E2",
  primary300: "#CBCBCB",
  primary400: "#AFAFAF",
  primary500: "#757575",
  primary600: "#545454",
  primary700: "#333333",

  electricBlue50: "#ECECFF",
  electricBlue100: "#D9D9FE",
  electricBlue200: "#B3B3FE",
  electricBlue300: "#8E8EFD",
  electricBlue400: "#6868FD",
  electricBlue500: "#4242FC",
  electricBlue600: "#3535CE",
  electricBlue700: "#2828A0",

  yellow50: "#FFFBEB",
  yellow100: "#FFF7D6",
  yellow200: "#FFEEAD",
  yellow300: "#FFE685",
  yellow400: "#FFDD5C",
  yellow500: "#FFD533",
  yellow600: "#CEAC29",
  yellow700: "#9D831F",

  red50: "#FBECEB",
  red100: "#F6D9D6",
  red200: "#EEB4AD",
  red300: "#E58E85",
  red400: "#D44333",
  red500: "#AE372A",
  red600: "#892C21",
  red700: "#5C1D16",

  green50: "#F0F9F4",
  green100: "#DAF0E3",
  green200: "#AEDDC2",
  green300: "#73C496",
  green400: "#3AA76D",
  green500: "#368759",
  green600: "#2B6B46",
  green700: "#1C472F",

  blue50: "#EFF8FF",
  blue100: "#D2EFFF",
  blue200: "#B6E5FF",
  blue300: "#92D7FE",
  blue400: "#6DCAFE",
  blue500: "#49BDFE",
  blue600: "#3A9BD1",
  blue700: "#2C79A5",

  purple50: "#F5F2FC",
  purple100: "#E3D7FD",
  purple200: "#BFA8F2",
  purple300: "#9168EC",
  purple400: "#7340E4",
  purple500: "#5D39BB",
  purple600: "#361D77",
  purple700: "#261650",

  gellyPurple: "#9B50D7",
  development: "#87550B",
  disabledDevelopment: "#846C4AB2",
  backgroundDevelopment: "#FBF6EF",
} as const;

export const gadgetColorsDark: GadgetColors = {
  neutralMin: "#000",
  neutralMax: "#FFF",

  primary50: "#333333",
  primary100: "#545454",
  primary200: "#757575",
  primary300: "#AFAFAF",
  primary400: "#CBCBCB",
  primary500: "#E2E2E2",
  primary600: "#EEEEEE",
  primary700: "#F6F6F6",

  electricBlue50: "#2828A0",
  electricBlue100: "#3535CE",
  electricBlue200: "#4242FC",
  electricBlue300: "#6868FD",
  electricBlue400: "#8E8EFD",
  electricBlue500: "#B3B3FE",
  electricBlue600: "#D9D9FE",
  electricBlue700: "#ECECFF",

  yellow50: "#5e4f13",
  yellow100: "#7b6718",
  yellow200: "#9D831F",
  yellow300: "#CEAC29",
  yellow400: "#FFD533",
  yellow500: "#FFDD5C",
  yellow600: "#FFE685",
  yellow700: "#FFEEAD",

  red50: "#5C1D16",
  red100: "#892C21",
  red200: "#AE372A",
  red300: "#D44333",
  red400: "#E58E85",
  red500: "#EEB4AD",
  red600: "#F6D9D6",
  red700: "#FBECEB",

  green50: "#1C472F",
  green100: "#2B6B46",
  green200: "#368759",
  green300: "#3AA76D",
  green400: "#73C496",
  green500: "#AEDDC2",
  green600: "#DAF0E3",
  green700: "#F0F9F4",

  blue50: "#2C79A5",
  blue100: "#3A9BD1",
  blue200: "#49BDFE",
  blue300: "#6DCAFE",
  blue400: "#92D7FE",
  blue500: "#B6E5FF",
  blue600: "#D2EFFF",
  blue700: "#EFF8FF",

  purple50: "#261650",
  purple100: "#361D77",
  purple200: "#5D39BB",
  purple300: "#7340E4",
  purple400: "#9168EC",
  purple500: "#BFA8F2",
  purple600: "#E3D7FD",
  purple700: "#F5F2FC",

  gellyPurple: "#8d3ccf",
  development: "#87550B",
  disabledDevelopment: "#846C4AB2",
  backgroundDevelopment: "#FBF6EF",
};

export const gadgetShadows = {
  selected: "0px 2px 0px 1px rgb(66, 66, 252, 0.3)",
  depth2: "0px 1px 0px rgba(0, 0, 0, 0.07)",
  depth3: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  depth4: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  depth5: "0px 1px 4px rgba(0, 0, 0, 0.16)",
} as const;

export const productTypography = {
  title: {
    fontFamily: "Inconsolata",
    fontSize: "20px",
    fontWeight: "600",
    lineHeight: "30px",
    letterSpacing: "0px",
    textAlign: "left",
  },
  navTitle: {
    fontFamily: "Inconsolata",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    letterSpacing: "1px",
    textAlign: "left",
  },
  heading: {
    fontFamily: "Inconsolata",
    fontSize: "16px",
    fontWeight: "700",
    lineHeight: "22px",
    letterSpacing: "0px",
    textAlign: "left",
  },
  subHeading: {
    fontFamily: "Inconsolata",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "20px",
    letterSpacing: "0px",
    textAlign: "left",
  },
  body: {
    fontFamily: "Inconsolata",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    letterSpacing: "0px",
    textAlign: "left",
  },
  caption: {
    fontFamily: "Inconsolata",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    letterSpacing: "0px",
    textAlign: "left",
  },
} as const;

export const getPrimitiveColors = (palette: GadgetColors) =>
  ({
    accent: palette.electricBlue500,
    accent50: palette.purple50,
    accent100: palette.purple100,
    accent200: palette.purple200,
    accent300: palette.purple300,
    accent400: palette.purple400,
    accent500: palette.purple500,
    accent600: palette.purple600,
    accent700: palette.purple700,

    negative50: palette.red50,
    negative100: palette.red100,
    negative200: palette.red200,
    negative300: palette.red300,
    negative400: palette.red400,
    negative500: palette.red500,
    negative600: palette.red600,
    negative700: palette.red700,

    warning50: palette.yellow50,
    warning100: palette.yellow100,
    warning200: palette.yellow200,
    warning300: palette.yellow300,
    warning400: palette.yellow400,
    warning500: palette.yellow500,
    warning600: palette.yellow600,
    warning700: palette.yellow700,

    positive50: palette.green50,
    positive100: palette.green100,
    positive200: palette.green200,
    positive300: palette.green300,
    positive400: palette.green400,
    positive500: palette.green500,
    positive600: palette.green600,
    positive700: palette.green700,

    primary50: palette.primary50,
    primary100: palette.primary100,
    primary200: palette.primary200,
    primary300: palette.primary300,
    primary400: palette.primary400,
    primary500: palette.primary500,
    primary600: palette.primary600,
    primary700: palette.primary700,
  } as const);

export const space = {
  scale0: "2px",
  scale100: "4px",
  scale200: "6px",
  scale300: "8px",
  scale400: "10px",
  scale500: "12px",
  scale550: "14px",
  scale600: "16px",
  scale650: "18px",
  scale700: "20px",
  scale750: "22px",
  scale800: "24px",
  scale850: "28px",
  scale900: "32px",
  scale950: "36px",
  scale1000: "40px",
  scale1200: "48px",
  scale1400: "56px",
  scale1600: "64px",
  scale2400: "96px",
  scale3200: "128px",
  scale4800: "192px",
} as const;

export const radii = {
  radius100: "2px",
  radius200: "4px",
  radius300: "8px",
  radius400: "12px",
};
